import React from "react";
import {
  Box,
  Grid,
  Typography,
  Card,
  CardContent,
  CardMedia,
  Container,
} from "@mui/material";

const WebSolutionsSection = (props) => {
  return (
    <Box
      sx={{
        color: "white",
        padding: { xs: "40px 20px", md: "60px 40px" },
        textAlign: "center",
      }}
    >
      <Container>
        {/* Heading */}
        {props?.headingText && (
          <Box
            sx={{
              paddingLeft: { xs: "auto", md: "24px" },
              paddingRight: { xs: "auto", md: "24px" },
            }}
          >
            <Typography
              sx={{
                fontSize: "18px",
                margin: "auto",
                mb: 4,
                color: "#fff",
              }}
            >
              {props?.headingText}
            </Typography>
          </Box>
        )}

        <Box
          sx={{
            padding: 5,
            border: "1px solid #DADFEF80",
            borderRadius: "12px",
            overflow: "hidden",
            backgroundColor: "#0A2C43B2",
          }}
        >
          <Typography
            variant="h5"
            sx={{ fontWeight: "bold", mb: 2, color: "#fff" }}
          >
            {props?.heading}
          </Typography>

          {props?.serviceContent && (
            <Typography
              variant="body1"
              sx={{ maxWidth: "800px", margin: "auto", mb: 4, color: "#fff" }}
            >
              {props?.serviceContent}
            </Typography>
          )}

          {/* Grid Layout */}
          <Grid container spacing={3} justifyContent="center">
            {props?.webSolutions.map((item, index) => (
              <Grid item xs={12} sm={6} md={4} key={index}>
                <Card
                  sx={{
                    background: "transparent",
                    color: "#122239",
                    borderRadius: "12px",
                    overflow: "hidden",
                    height: { xs: "auto", md: "400px" },
                    "&:hover": {
                      "& .card-content": {
                        background:
                          "linear-gradient(to bottom, #B6BFE04D , #9D3DBA)", // Gradient on hover
                      },
                    },
                  }}
                >
                  <CardMedia
                    component="img"
                    height="180"
                    image={item.image}
                    alt={item.title}
                  />
                  <CardContent
                    className="card-content" // Add this class to target in the hover effect
                    sx={{
                      background:
                        "linear-gradient(to bottom, #4e5f70 , #2a265b)", // Gradient background
                      padding: "16px",
                      borderBottom: `3px solid ${item.bgColor}`,
                      borderLeft: `3px solid ${item.bgColor}`,
                      borderRight: `3px solid ${item.bgColor}`,
                      height: { xs: "auto", md: "200px" },
                      borderBottomLeftRadius: "12px",
                      borderBottomRightRadius: "12px",
                      transition: "background 0.3s ease", // Smooth transition for background color change
                      "&:hover": {
                        "& .card-content": {
                          borderBottom: `3px solid #fff`,
                          borderLeft: `3px solid #fff`,
                          borderRight: `3px solid #fff`,
                        },
                      },
                    }}
                  >
                    <Typography
                      sx={{
                        fontWeight: "bold",
                        mb: 1,
                        color: "#fff",
                        fontSize: "22px",
                      }}
                    >
                      {item.title}
                    </Typography>
                    <Typography variant="body1" sx={{ color: "#fff" }}>
                      {item.description}
                    </Typography>
                  </CardContent>
                </Card>
              </Grid>
            ))}
          </Grid>
        </Box>
      </Container>
    </Box>
  );
};

export default WebSolutionsSection;
